"use client";
import { useState, useEffect } from "react";
import { FaSave, FaTimes } from "react-icons/fa";

const ConfigEditor = ({ config, onSave }) => {
  const [configJson, setConfigJson] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    setConfigJson(JSON.stringify(config, null, 2));
  }, [config]);

  const handleChange = (e) => {
    setConfigJson(e.target.value);
    setError("");
  };

  const handleSave = () => {
    try {
      const newConfig = JSON.parse(configJson);
      onSave(newConfig);
      setError("");
    } catch (err) {
      setError("Invalid JSON: " + err.message);
    }
  };

  return (
    <div className="bg-white border border-gray-200 rounded-md shadow-sm">
      <div className="flex justify-between items-center p-3 border-b border-gray-200 bg-gray-50">
        <h3 className="text-lg font-medium text-gray-700">
          Table Configuration
        </h3>
        <div className="flex space-x-2">
          <button
            onClick={handleSave}
            className="flex items-center px-3 py-1.5 bg-primary text-white rounded-md text-sm hover:bg-primary/90"
            disabled={!!error}
          >
            <FaSave className="mr-1" /> Save
          </button>
          <button
            onClick={() => onSave(config)}
            className="flex items-center px-3 py-1.5 bg-gray-200 text-gray-700 rounded-md text-sm hover:bg-gray-300"
          >
            <FaTimes className="mr-1" /> Cancel
          </button>
        </div>
      </div>
      <div className="p-3">
        <textarea
          value={configJson}
          onChange={handleChange}
          className="w-full h-80 font-mono text-sm p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
          spellCheck="false"
        />
        {error && <div className="mt-2 text-red-500 text-sm">{error}</div>}
      </div>
    </div>
  );
};

export default ConfigEditor;
